var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.id + '-' + _vm.itemIndex,staticClass:"pdp-notice-alert",class:_vm.alertType,attrs:{"id":_vm.id + '-' + _vm.itemIndex}},[_c('i',{class:_vm.alertIcon}),_c('p',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.alertMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }